import { useMemo } from "react";
import { MapPin } from "lucide-react";
import { StateManager } from "../service/StateManager";
import EventCard from "./EventCard";
import "../../../css/OnRoad.css";

export default function PhaseSection({ fase, ultimos, onReport }) {
    const eventos = useMemo(() => {
        // Validar que StateManager.EVENTOS exista
        if (!StateManager.EVENTOS) {
            console.error('StateManager.EVENTOS no está definido');
            return [];
        }

        const eventosOrden = [
            StateManager.EVENTOS.LLEGADA, 
            StateManager.EVENTOS.SALIDA
        ];

        return eventosOrden.map(evento => {

            const estadoDetallado = ultimos?.[evento] || {
                estado: StateManager.ESTADOS_EVENTO.BLOQUEADO,
                gruposReportados: [],
                gruposPendientes: [],
                totalGrupos: 0,
                progreso: 0,
                esMixto: false
            };
            return {
                evento,
                estadoDetallado,
                disabled: estadoDetallado.estado === StateManager.ESTADOS_EVENTO.BLOQUEADO ||
                         (estadoDetallado.estado === StateManager.ESTADOS_EVENTO.REPORTADO && 
                          !estadoDetallado.esMixto)
            };
        });
    }, [ultimos]);

    const faseLabel = {
        [StateManager.FASES.CARGUE]: "En Origen – Cargue",
        [StateManager.FASES.DESCARGUE]: "En Destino – Descargue"
    }[fase] || fase;

    return (
        <div className="phase-section">
            <div className="phase-title-simple">
                <MapPin size={22} />
                <span>{faseLabel}</span>
            </div>

            {/* Grid de eventos */}
            <div className="events-grid">
                {eventos.map((evento, index) => (
                    <EventCard
                        key={evento.evento}
                        evento={evento.evento}
                        estadoDetallado={evento.estadoDetallado}
                        disabled={evento.disabled}
                        onClick={() => onReport({ fase, evento: evento.evento })}
                        gridPosition={index + 1}
                        fase={fase} 
                    />
                ))}
            </div>
        </div>
    );
}